import z from 'zod';

import { Draft } from '../../common';
import { getSchema as getOrgSchema } from '../orgSchema';
import { IAIRecord } from './aiInterface';
import { AISchema } from './aiSchema';
import { IFieldErrors, ValidationError } from '../../validation';

export const AIRecord = z.object({
  ai: AISchema
});

export const getSchema = (update: Draft<IAIRecord>, preparing: boolean) => {
  return AIRecord.extend({
    org: getOrgSchema(update.org || {}, preparing, 'ai')
  });
};


export const validate = (request: Draft<IAIRecord>, preparing: boolean) => {
  const schema = getSchema(request, preparing);
  try {
    // Ensure there are changes from the original record
    const validated = schema.parse(request);
    return {
      ...validated
    };
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};